<template lang="pug">
div    
    modal(v-show="isShowModal_",:titulo="'CAMBIO DE PASSWORD'" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
            div(slot='body') 
                .form-group
                    .form-row
                        .col-md-12.col-sm-12
                            label PASSWORD NUEVO
                            input.form-control.form-control-sm(v-model="parameter.NewPassword", type="password", @keypress.enter="sendInfo()") 
                    .form-row
                        .col-md-12.col-sm-12
                            label REPITA PASSWORD  
                            input.form-control.form-control-sm(v-model="parameter.CheckNewPassword", type="password", @keypress.enter="sendInfo()")
            div(slot='footer')                      
                button.btn.btn-primary(@click="sendInfo()") CAMBIAR
                       
</template>
<script>
 
import modal from "../../../complementos/modal.vue"
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },
    data(){
        return{ 
                TypeAccount:'' ,
                pass:''
            }
    },
    components:{
        modal
    },
    mounted(){
        this.TypeAccount=this.$info.typeAccount
        console.log(this.$info)
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{  
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)            
                    this.$emit("sendInfo",this.parameter)
                }         
            },
            validate(){
                if(this.parameter.NewPassword=='' || this.parameter.NewPassword==null ){
                    this.$msgbox.show("Ingrese Nuevo Password","Alerta")
                    return false
                } 
                else if(this.parameter.CheckNewPassword=='' || this.parameter.CheckNewPassword==null ){
                    this.$msgbox.show("Ingrese Password para Confirmar","Alerta")
                    return false
                }
                else if(this.parameter.CheckNewPassword!=this.parameter.NewPassword ){
                    this.$msgbox.show("Los Password no Coinciden","Alerta")
                    return false
                } 
                else{
                    return true
                }
            }
    }

    
}
</script>